<template>
  <div>
    <CRow>
      <CCol lg="12">
        <CCard>
          <CCardHeader>
            <slot name="header">
              <CIcon name="cil-grid" />
              {{ title }}
            </slot>
          </CCardHeader>

          <CCardBody>
            <template v-if="!isLoading">
              <TableButton
                :visibilityShow="visibilityShow"
                :title="title"
                @addForm="addForm"
                @showHide="showHide"
                @exportXls="exportXls"
                @myListBoxOnCheckChange="myListBoxOnCheckChange($event)"
              ></TableButton>

              <CRow>
                <CCol sm="12">
                  <JqxGrid
                    v-if="items"
                    ref="myGrid"
                    :width="'100%'"
                    :source="items"
                    :columns="fields"
                    :columnsresize="true"
                    :sortable="true"
                    :pageable="true"
                    :autoheight="true"
                    :showfilterrow="true"
                    :filterable="true"
                    :enablebrowserselection="false"
                    :enablehover="true"
                    :editable="false"
                    :altrows="true"
                    :localization="localization"
                    :selectionmode="'multiplerowsadvanced'"
                  >
                  </JqxGrid>
                </CCol>
              </CRow>
            </template>
            <Loading v-else></Loading>
          </CCardBody>
        </CCard>
      </CCol>
    </CRow>

    <CModal
      title="Modal title"
      color="success"
      size="xl"
      :closeOnBackdrop="false"
      :show.sync="addButton"
    >
      <template #header>
        <h6 class="modal-title">Add Form {{ title }}</h6>
      </template>
      <Loading v-if="isLoading"></Loading>

      <div v-else>
        <CForm>
          <CRow>
            <CCol md="4">
              <CInput
                label="Name"
                invalid-feedback="Name should be filled"
                required
                v-model="$v.partnershipGroupForm.name.$model"
                :is-valid="!$v.partnershipGroupForm.name.$invalid"
              />
            </CCol>
            <!-- <CCol md="4">
              <div class="form-group">
                <label for="flag">Show</label>
                <model-select
                  class="form-control"
                  id="flag"
                  :options="showList"
                  v-model="$v.partnershipGroupForm.show.$model"
                  :isError="$v.partnershipGroupForm.show.$invalid"
                  placeholder="-- Harap pilih salah satu --"
                ></model-select>
                <div
                  v-if="$v.partnershipGroupForm.show.$invalid"
                  class="invalid-feedback-custom"
                >
                  Redirect be filled.
                </div>
              </div>
            </CCol> -->
          </CRow>
          <CRow>
            <CCol md="6">
              <label for="nik">Opening Description</label>
              <quill-editor
                style="height: 200px; margin-bottom: 70px"
                :content="content"
                :options="editorOption"
                v-model="$v.partnershipGroupForm.opening_description.$model"
                @change="onEditorChange($event)"
              >
              </quill-editor>
              <div
                v-if="$v.partnershipGroupForm.opening_description.$invalid"
                class="invalid-feedback-custom"
              >
                Opening Description harus di isi.
              </div>
            </CCol>
            <CCol md="6">
              <label for="closing description">Closing Description</label>
              <quill-editor
                style="height: 200px; margin-bottom: 70px"
                :content="content2"
                :options="editorOption2"
                v-model="$v.partnershipGroupForm.closing_description.$model"
                @change="onEditorChange2($event)"
              >
              </quill-editor>
              <div
                v-if="$v.partnershipGroupForm.closing_description.$invalid"
                class="invalid-feedback-custom"
              >
                Closing Description harus di isi.
              </div>
            </CCol>
          </CRow>
        </CForm>
      </div>

      <template #footer>
        <CButton @click="cancelForm" color="danger">
          <i class="fa fa-undo"></i>
          Cancel
        </CButton>
        <CButton
          @click="submitForm"
          :disabled="$v.partnershipGroupForm.$invalid"
          color="success"
        >
          <i class="fa fa-save"></i>
          Accept
        </CButton>
      </template>
    </CModal>
  </div>
</template>

<script>
import tableInterfaces from "@/templates/_table_interfaces.js";
import { required } from "vuelidate/lib/validators";
import Loading from "@/templates/Loading.vue";
import TableButton from "@/templates/TableButton";
import JqxGrid from "jqwidgets-scripts/jqwidgets-vue/vue_jqxgrid.vue";

import "quill/dist/quill.core.css";
import "quill/dist/quill.snow.css";
import "quill/dist/quill.bubble.css";
import { quillEditor } from "vue-quill-editor";
import Quill from "quill";

export default {
  name: "PartnershipGroup",
  components: { Loading, quillEditor, JqxGrid, TableButton },
  data() {
    return {
      title: "Partnership Group",
      source: {
        localdata: [],
        datafields: [
          { name: "id", type: "number" },
          { name: "name", type: "string" },
          { name: "opening_description", type: "string" },
          { name: "closing_description", type: "string" },
          { name: "show", type: "number" },
        ],
        datatype: "json",
      },
      editrow: -1,

      fields: [
        {
          datafield: "name",
          columntype: "textbox",
          filtertype: "textbox",
          text: "Nama",
          width: 200,
        },
        {
          datafield: "opening_description",
          columntype: "textbox",
          filtertype: "textbox",
          text: "Opening Description",
          cellsalign: "center",
          align: "center",
        },
        {
          datafield: "closing_description",
          columntype: "textbox",
          filtertype: "textbox",
          text: "Closing Description",
          cellsalign: "center",
          align: "center",
        },
        {
          text: "Action",
          align: "center",
          name: "EditAction",
          columntype: "button",
          width: 60,
          sortable: false,
          filtertype: "none",
          menu: false,
          cellsrenderer: () => {
            return "Edit";
          },
          buttonclick: (row) => {
            let dataRecord = this.$refs.myGrid.getrowdata(row);
            let path = this.$route.path.split("/");

            this.$router.push({
              path: path.hasOwnProperty("2")
                ? path[2] + "/detail/" + dataRecord.id
                : "detail/" + dataRecord.id,
            });
          },
        },
      ],

      partnershipGroupForm: tableInterfaces.partnership_group,
      items: null,
      showList: [
        { value: "1", text: "Show" },
        { value: "0", text: "Not Show" },
      ],
      isLoading: false,
      isEdit: false,
      addButton: false,
      content: "",
      content2: "",
      editorOption: {}, // data quill
      editorOption2: {},
      localization: getLocalization("en"),
      visibilityShow: false,
    };
  },
  validations: {
    partnershipGroupForm: {
      name: { required },
      opening_description: { required },
      closing_description: { required }
    //   show: { required },
    },
  },
  notifications: {
    showErrorNotification: {
      title: "Error Title",
      message: "Messages",
      type: "error",
    },
    showInfoNotification: {
      title: "Info Title",
      message: "Messages",
      type: "info",
    },
  },
  methods: {
    //NewTable Function --start
    exportXls: function () {
      this.$refs.myGrid.exportdata("xls", "order");
    },
    exportPdf: function () {
      this.$refs.myGrid.exportdata("pdf", "order");
    },
    myListBoxOnCheckChange: function (event) {
      this.$refs.myGrid.beginupdate();
      if (event.args.checked) {
        this.$refs.myGrid.showcolumn(event.args.value);
      } else {
        this.$refs.myGrid.hidecolumn(event.args.value);
      }
      this.$refs.myGrid.endupdate();
    },
    showHide: function () {
      this.visibilityShow = !this.visibilityShow;
    },
    // NewTable Function --end
    init: function () {
      this.isEdit = false;
      this.cancelForm();
      this.getPartnershipListing();
    },
    getPartnershipListing: function () {
      this.isLoading = true;
      this.axios
        .get("console/partnership/group/listing")
        .then((response) => {
          if (response.data.status === 2000) {
            //this.items = response.data.data;
            const temp = this.source;
            temp.localdata = response.data.data;
            this.items = new jqx.dataAdapter(temp);

            this.showInfoNotification({
              title: this.title,
              message: response.data.message,
            });
          } else {
            this.showErrorNotification({
              title: this.title,
              message: response.data.message,
            });
          }
        })
        .catch((error) => {
          this.showErrorNotification({
            title: this.title,
            message: error,
          });
        })
        .finally(() => {
          this.isLoading = false;
        });
    },
    addForm: function () {
      this.addButton = true;
      this.resetForm();
    },
    cancelForm: function () {
      this.addButton = false;
      this.resetForm();
    },
    editForm: function (item) {
      this.addForm();
      this.isEdit = true;
      this.partnershipGroupForm = item;
    },
    resetForm: function () {
      for (var i in tableInterfaces.partnership_group) {
        tableInterfaces.partnership_group[i] = null;
      }
      this.partnershipGroupForm = tableInterfaces.partnership_group;
    },
    submitForm: function (event) {
      event.preventDefault();
      if (confirm("Are you sure want to add this partnership ?")) {
        let path = this.$route.path.split("/");
        this.isLoading = true;
        this.axios
          .post("console/partnership/group/add", this.partnershipGroupForm)
          .then((response) => {
            if (response.data.status === 2000) {
              this.showInfoNotification({
                title: this.title,
                message: response.data.message,
              });
              this.$router.push({
                path: path[2] + "/detail/" + response.data.id,
              });
            } else {
              this.showErrorNotification({
                title: this.title,
                message: response.data.message,
              });
            }
          })
          .catch((error) => {
            this.showErrorNotification({
              title: this.title,
              message: error,
            });
          })
          .finally(() => {
            this.isLoading = false;
            this.init();
          });
      }
    },
    onEditorChange({ quill, html, text }) {
      this.content = html;
      this.partnershipGroupForm.opening_description = html;
    },
    onEditorChange2({ quill, html, text }) {
      this.content2 = html;
      this.partnershipGroupForm.closing_description = html;
    },
  },
  mounted() {
    this.init();
  },
};
</script>

<style>
.ui.selection.dropdown.error {
  border-color: #e55353;
}
.ui.selection.dropdown {
  border-color: #2eb85c;
}
</style>
